module.exports = __webpack_public_path__ + "img/download.3d7e3c50.svg";